// extracted by mini-css-extract-plugin
export default {"aboutTitle":"styles_aboutTitle__wp07I","certLabel":"styles_certLabel__WykiA","certStatus":"styles_certStatus__6WqYb"};